<template>
<div class="create-leaps-action-overlay">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" v-on:click="updateHideCreateLeapsActionOverlayFlag($event)">
                    <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right">
                  <span>Title</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-4 col-lg-4 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px">
                      <input type="text" class="form-control" v-model="objToPass.ActionName" :maxlength="maxLength">
                    </div>
                  </div>
                </div> 
                <div class="col-md-1 col-lg-1 text-align-right create-lesson-input-text-style padding-right-0Px"></div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="checkbox">
                      <label><input type="checkbox" v-model="objToPass.IsActive">Is Active</label>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right">
                  <span>Energy</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-4 col-lg-4 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px" id="vueMultiSelect">
                      <!-- <vue-multi-select
                        search
                        :filters="energyFilters"
                        btnClass="cssClass"
                        v-model="selectedEnergyValues"
                        :btnLabel="btnEnergyLabel"
                        :options="energyOptions"
                        :selectOptions="energyData" /> -->
                      <select class="form-control" v-model="selectedEnergyValues">
                        <option value='-1' disabled>Select</option>
                        <option v-for="energyObj in energyData" v-bind:key="energyObj.energyid" :courseObj="energyObj" :value="energyObj.energyid">{{ energyObj.name }}</option>
                      </select>
                    </div>
                  </div>
                </div> 
                <div class="col-md-1 col-lg-1 text-align-right create-lesson-input-text-style padding-left-0Px padding-right-0Px">
                  <span>Affirmation</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12 text-align-left" id="vueMultiSelect">
                      <vue-multi-select
                        search
                        :filters="affirmationFilters"
                        btnClass="cssClass"
                        v-model="selectedAffirmationValues"
                        :btnLabel="btnAffirmationLabel"
                        :options="affirmationOptions"
                        :selectOptions="affirmationData" />
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <span>Meditation</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-4 col-lg-4 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px" id="vueMultiSelect">
                      <vue-multi-select
                        search
                        :filters="meditationFilters"
                        btnClass="cssClass"
                        v-model="selectedMeditationValues"
                        :btnLabel="btnMeditationLabel"
                        :options="meditationOptions"
                        :selectOptions="meditationData" />
                    </div>
                  </div>
                  <!-- select box -->
                  
                </div> 
                <div class="col-md-6 col-lg-6 text-align-right create-lesson-input-text-style padding-right-0Px">
                </div>  
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right">
                  Toolkit
                </div>
                <div class="col-md-4 col-lg-4 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px padding-right-0Px">
                      <input type="file" id="toolkitFile" accept=".pdf">
                    </div>
                  </div>
                </div> 
                <div class="col-md-1 col-lg-1 text-align-right create-lesson-input-text-style padding-right-0Px">
                  Course
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="objToPass.CourseMasterId">
                        <option value='-1' disabled>Select</option>
                        <option v-for="courseObj in getCourseList" v-bind:key="courseObj.CourseId" :courseObj="courseObj" :value="courseObj.CourseMasterId">{{ getCourseName(courseObj) }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right">
                  Version
                </div>
                <div class="col-md-4 col-lg-4 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px">
                      <input type="text" class="form-control" v-model="objToPass.ActionVersion" :maxlength="maxLength">
                    </div>
                  </div>
                </div> 
                <div class="col-md-1 col-lg-1 text-align-right create-lesson-input-text-style padding-right-0Px">
                  <span>Introduction</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12 padding-right-0Px text-align-left">
                      <span class="cursor-pointer text-color-blue" @click="openRTFDescOverlay($event, 'action-intro')"><u>Open Editor</u></span>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>
              
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right">
                  <span>Short Description</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-4 col-lg-4 padding-right-0Px">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-0Px padding-right-0Px text-align-left">
                      <span class="cursor-pointer text-color-blue" @click="openRTFDescOverlay($event, 'action-detail')"><u>Open Editor</u></span>
                    </div>
                  </div>
                </div> 
                <div class="col-md-1 col-lg-1 text-align-right create-lesson-input-text-style padding-right-0Px">
                  <span>Long Description</span>
                  <span class="text-color-red">*</span>
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12 padding-right-0Px text-align-left">
                      <span class="cursor-pointer text-color-blue" @click="openRTFDescOverlay($event, 'action-description')"><u>Open Editor</u></span>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="createLeapsAction">Create</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <add-rtf-description-overlay v-if="openDescriptionOverlay" @closeRtfEditorOverlay="closeRTFEditor" :addedDescription="rtfDesc"></add-rtf-description-overlay>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
 </div>
 </div>
</template>

<script>
import tinymce from 'vue-tinymce-editor'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { leapsActionService } from '@/server-util/leaps-action-service'
import Loader from '@/components/dashboard/Loader'
import { filter, forEach } from 'lodash'
import vueMultiSelect from 'vue-multi-select'
import 'vue-multi-select/dist/lib/vue-multi-select.css'
import { courseService } from '@/server-util/course-service'
import AddRTFCourseDescriptionOverlay from '@/components/AddRTFCourseDescriptionOverlay'
import { leapsEnergyService } from '@/server-util/leaps-energy-service'
import { leapsAffirmationService } from '@/server-util/leaps-affirmation-service'
import { leapsMeditationService } from '@/server-util/leaps-meditation-service'
export default {
  created: function () {
    this.getLeapsEnergyList()
    this.getLeapsMeditationList()
  },
  data: function () {
    return {
      rtfDesc: '',
      constants: constants,
      maxLength: constants.Leaps_Title_Max_Length,
      showAlertDialog: false,
      errorMsg: '',
      objToPass: {
        ActionName: '',
        ActionDescription: '',
        IsActive: false,
        ActionIntro: '',
        ActionDetail: '',
        ActionVersion: '',
        CourseMasterId: -1,
        ActionAffirmations: [],
        ActionEnergies: []
      },
      showSpinner: false,
      hasCreatedLeapsActionCreatedSuccessfully: false,
      createdObj: null,
      openDescriptionOverlay: false,
      selectedRTFEditorEnum: 'none',
      btnEnergyLabel: selectedEnergyValues => selectedEnergyValues.length > 0 ? selectedEnergyValues.length === 1 ? '1 Energy is selected' : selectedEnergyValues.length + ' Energies are selected' : 'Select Single/Multiple Engeries',
      selectedEnergyValues: -1,
      energyData: [],
      energyOptions: {
        multi: true,
        groups: false,
        cssSelected: option => (option.selected ? { 'color': '#f39c12', 'font-weight': '500', 'opacity': '1' } : { 'opacity': '0.8' })
      },
      energyFilters: [{
        nameAll: 'Select all',
        nameNotAll: 'Deselect all',
        func () {
          return true
        }
      }],
      btnMeditationLabel: selectedMeditationValues => selectedMeditationValues.length > 0 ? selectedMeditationValues.length === 1 ? '1 Meditation is selected' : selectedMeditationValues.length + ' Meditations are selected' : 'Select Single/Multiple Meditation',
      selectedMeditationValues: [],
      meditationData: [],
      meditationOptions: {
        multi: true,
        groups: false,
        cssSelected: option => (option.selected ? { 'color': '#f39c12', 'font-weight': '500', 'opacity': '1' } : { 'opacity': '0.8' })
      },
      meditationFilters: [{
        nameAll: 'Select all',
        nameNotAll: 'Deselect all',
        func () {
          return true
        }
      }],
      btnAffirmationLabel: selectedAffirmationValues => selectedAffirmationValues.length > 0 ? selectedAffirmationValues.length === 1 ? '1 Affirmation is selected' : selectedAffirmationValues.length + ' Affirmations are selected' : 'Select Single/Multiple Affirmations',
      selectedAffirmationValues: [],
      affirmationData: [],
      affirmationOptions: {
        multi: true,
        groups: false,
        cssSelected: option => (option.selected ? { 'color': '#f39c12', 'font-weight': '500', 'opacity': '1' } : { 'opacity': '0.8' })
      },
      affirmationFilters: [{
        nameAll: 'Select all',
        nameNotAll: 'Deselect all',
        func () {
          return true
        }
      }]
    }
  },
  name: 'create-leaps-action-overlay',
  methods: {
    getLeapsEnergyList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        // AK: Check weather leapsEnergyList is already present or not?
        if (storeObj.state.leapsEnergyList.length === 0) {
          this.$store.state.isLoading = true
        }
        leapsEnergyService
          .getLeapsEnergyList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.leapsEnergyList = responseObj.data
              if (this.$store.state.isLoading === true) {
                this.$store.state.isLoading = false
              }
              this.getLeapsAffirmationList()
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS ENGERY LIST'
        )
      }
    },
    getLeapsAffirmationList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        // AK: Check weather leapsEnergyList is already present or not?
        if (storeObj.state.leapsAffirmationList.length === 0) {
          this.$store.state.isLoading = true
        } else {
          this.setDefaultValues()
        }
        leapsAffirmationService
          .getLeapsAffirmationList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.leapsAffirmationList = responseObj.data
              if (this.$store.state.isLoading === true) {
                this.$store.state.isLoading = false
              }
              this.setDefaultValues()
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS AFFIRMATION LIST'
        )
      }
    },
    getLeapsMeditationList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        if (storeObj.state.leapsMeditationList.length === 0) {
          this.$store.state.isLoading = true
        }
        leapsMeditationService
          .getLeapsMeditationList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              storeObj.state.leapsMeditationList = responseObj.data
              if (this.$store.state.isLoading === true) {
                this.$store.state.isLoading = false
              }
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS MEDITATION LIST'
        )
      }
    },
    closeRTFEditor (value) {
      this.openDescriptionOverlay = value.closeRtfEditorOverlay
      switch (this.selectedRTFEditorEnum) {
        case 'none':
        default:
          break
        case 'action-intro':
          this.objToPass.ActionIntro = value.description
          break
        case 'action-detail':
          this.objToPass.ActionDetail = value.description
          break
        case 'action-description':
          this.objToPass.ActionDescription = value.description
          break
      }
      this.selectedRTFEditorEnum = 'none'
      this.rtfDesc = ''
    },
    openRTFDescOverlay: function (event, rtfEditorEnum) {
      this.selectedRTFEditorEnum = rtfEditorEnum
      switch (this.selectedRTFEditorEnum) {
        case 'none':
        default:
          break
        case 'action-intro':
          this.rtfDesc = this.objToPass.ActionIntro
          break
        case 'action-detail':
          this.rtfDesc = this.objToPass.ActionDetail
          break
        case 'action-description':
          this.rtfDesc = this.objToPass.ActionDescription
          break
      }
      this.openDescriptionOverlay = true
    },
    getCourses: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== '' && storeObj.state.access_token !== null) {
        // AK: Check weather Course List is already present on not
        if (storeObj.state.course_list.length === 0) {
          this.$store.state.isLoading = true
        }

        courseService.listCourses(storeObj.state.access_token)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              storeObj.state.course_list = responseObj.data
              this.$store.state.isLoading = false
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.$store.state.isLoading = false
          })
      } else {
        console.log('ACCESS TOKEN IS NOT FOUND HENCE DECLINE GET COURSE LIST OPERATION')
      }
    },
    getCourseName: function (courseObj) {
      var nameToReturn = ''
      if (courseObj.CourseTitle !== undefined && courseObj.CourseTitle !== 'undefined' && courseObj.CourseTitle !== null && courseObj.CourseTitle !== 'null' && courseObj.CourseTitle !== '') {
        nameToReturn = courseObj.CourseTitle
      }
      if (courseObj.SubTitle !== undefined && courseObj.SubTitle !== 'undefined' && courseObj.SubTitle !== null && courseObj.SubTitle !== 'null' && courseObj.SubTitle !== '') {
        nameToReturn += ' [' + courseObj.SubTitle + ']'
      }
      return nameToReturn
    },
    setDefaultValues: function () {
      this.energyData = []
      this.affirmationData = []
      this.meditationData = []
      forEach(this.$store.state.leapsEnergyList, (obj) => {
        var objToPush = {
          name: obj.EnergyTitle,
          energyid: obj.EnergyId
        }
        this.energyData.push(objToPush)
      })
      forEach(this.$store.state.leapsAffirmationList, (obj) => {
        var objToPush = {
          name: obj.AffirmationTitle,
          affirmationlibraryid: obj.AffirmationLibraryId
        }
        this.affirmationData.push(objToPush)
      })
      this.getCourses()
      forEach(this.$store.state.leapsMeditationList, (obj) => {
        var objToPush = {
          name: obj.MeditationTitle,
          meditationLibraryId: obj.MeditationLibraryId
        }
        this.meditationData.push(objToPush)
      })
    },
    updateHideCreateLeapsActionOverlayFlag: function (event) {
      var objToReturn = {
        closeOverlay: true,
        createdObj: null
      }
      this.$emit('emittedValue', objToReturn)
    },
    createLeapsAction: function () {
      var storeObj = this.$store
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (
          storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
        ) {
          var toolkitFileUrl = document.getElementById('toolkitFile').files[0]
          if (toolkitFileUrl === undefined || toolkitFileUrl === 'undefined' || toolkitFileUrl === null) {
            toolkitFileUrl = null
          }
          const formData = new FormData()
          formData.append('IsActive', this.objToPass.IsActive)
          formData.append('ActionIntro', this.objToPass.ActionIntro)
          formData.append('ActionName', this.objToPass.ActionName)
          formData.append('ActionDescription', this.objToPass.ActionDescription)
          formData.append('ActionDetail', this.objToPass.ActionDetail)
          formData.append('ActionVersion', this.objToPass.ActionVersion !== undefined && this.objToPass.ActionVersion !== 'undefined' && this.objToPass.ActionVersion !== null && this.objToPass.ActionVersion !== 'null' && this.objToPass.ActionVersion !== '' && this.objToPass.ActionVersion.trim().length !== 0 ? this.objToPass.ActionVersion : null)
          formData.append('CourseMasterId', this.objToPass.CourseMasterId !== -1 ? this.objToPass.CourseMasterId : null)
          formData.append('ActionToolkit', toolkitFileUrl)
          var objToPush = []
          forEach(this.selectedAffirmationValues, (obj) => {
            objToPush.push(obj.affirmationlibraryid)
          })
          formData.append('ActionAffirmations', JSON.stringify(objToPush))
          objToPush = []
          // forEach(this.selectedEnergyValues, (obj) => {
          //   objToPush.push(obj.energyid)
          // })
          objToPush.push(this.selectedEnergyValues)
          formData.append('ActionEnergies', JSON.stringify(objToPush))
          objToPush = []
          forEach(this.selectedMeditationValues, (obj) => {
            objToPush.push(obj.meditationLibraryId)
          })
          formData.append('ActionMeditations', JSON.stringify(objToPush))
          this.$store.state.isLoading = true
          leapsActionService
            .createLeapsAction(
              storeObj.state.access_token,
              formData
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                responseObj.data.ActionSearchbleField = responseObj.data.ActionName
                if (responseObj.data.ActionVersion !== undefined && responseObj.data.ActionVersion !== 'undefined' && responseObj.data.ActionVersion !== null && responseObj.data.ActionVersion !== 'null' && responseObj.data.ActionVersion !== '' && responseObj.data.ActionVersion.trim().length !== 0) {
                  responseObj.data.ActionSearchbleField += ' ' + responseObj.data.ActionVersion
                }
                storeObj.state.leapsActionList.push(responseObj.data)
                this.hasCreatedLeapsActionCreatedSuccessfully = true
                this.createdObj = responseObj.data
                this.showAlertDialog = true
                this.errorMsg = '\'' + this.objToPass.ActionName + '\' action added successfully.'
                this.$store.state.isLoading = false
              } else {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined CREATE NEW LEAPS ACTION.'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.hasCreatedLeapsActionCreatedSuccessfully) {
        // AK: Hide Create LEAPS Action Overlay
        var objToReturn = {
          closeOverlay: true,
          createdObj: this.createdObj
        }
        this.$emit('emittedValue', objToReturn)
        this.hasCreatedLeapsActionCreatedSuccessfully = false
        this.createdObj = null
      }
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    validateRequiredFieldBeforeSubmit: function () {
      var toolkitFileUrl = document.getElementById('toolkitFile').files[0]
      if (this.objToPass.ActionName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      } else if (this.selectedEnergyValues === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an energy.'
        return false
      } else if (this.selectedAffirmationValues.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Atleast one affirmation is required.'
        return false
      } else if (this.selectedMeditationValues.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Atleast one meditation is required.'
        return false
      } else if (toolkitFileUrl !== undefined && toolkitFileUrl !== null && !this.checkPdfFileExtesion(document.getElementById('toolkitFile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid .pdf file for caption.'
        return false
      } else if (this.stripHtml(this.objToPass.ActionIntro).trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Introduction can\'t be empty.'
        return false
      } else if (this.stripHtml(this.objToPass.ActionDetail).trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Short Description can\'t be empty.'
        return false
      } else if (this.stripHtml(this.objToPass.ActionDescription).trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Long Description can\'t be empty.'
        return false
      }
      return true
    },
    checkPdfFileExtesion: function (fileName) {
      var exts = ['.pdf']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'tinymce': tinymce,
    'add-rtf-description-overlay': AddRTFCourseDescriptionOverlay,
    'vue-multi-select': vueMultiSelect
  },
  computed: {
    getCourseList: {
      get: function () {
        return filter(this.getGlobalCourseList, (obj) => {
          return obj.Type !== constants.CourseType.RecommendationAssessment && obj.Type !== constants.CourseType.M365
        })
      }
    },
    getGlobalCourseList: {
      get: function () {
        return this.$store.state.course_list
      }
    }
  }
}
</script>
<style>
#vueMultiSelect .select {
  width: 100%;
  min-width: 100%;
}

#vueMultiSelect button.btn-select {
  min-width: 100%;
}
#vueMultiSelect .select .checkboxLayer {
  width: 100%;
}
#vueMultiSelect .select .helperButton {
  width: 100px !important;
  color: #000;
}
#vueMultiSelect .select .helperButton:hover {
  background-color: #ffffff;
  color: #000;
}
#vueMultiSelect ul>li .margin-left-20 {
  background-color: #fff;
  word-wrap: break-word;
  display: inline-block;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: normal;
  line-break: strict;
  hyphens: none;
  -webkit-hyphens: none;
  -moz-hyphens: none;
}

</style>

<style scoped>
.text-color-red {
  color: red;
}
.text-color-blue {
  color: blue;
}
.create-lesson-label-text-style {
  color: #34495e;
  font-size: 12px;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 7%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 15px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
</style>





// WEBPACK FOOTER //
// src/components/leaps/action/CreateLeapsActionOverlay.vue